import { http } from '@/api/http';
import { DISTANCE_API_ORIGIN } from '@/constants/env.constants';
import { RouteDistancesResponse, RouteDurationsParams, RouteDurationsResponse } from './mission-planner-distance.types';
import { getMissionPlannerDistanceApiUrl } from './mission-planner-distance.paths';

const getDurations = async (body: RouteDurationsParams[]) => {
  const res = await http<RouteDurationsResponse>({
    url: getMissionPlannerDistanceApiUrl.getDurations(),
    baseURL: DISTANCE_API_ORIGIN,
    method: 'POST',
    data: body,
  });

  return res.data;
};

const getDistances = async (body: RouteDurationsParams[]) => {
  const res = await http<RouteDistancesResponse>({
    url: getMissionPlannerDistanceApiUrl.getDistances(),
    baseURL: DISTANCE_API_ORIGIN,
    method: 'POST',
    data: body,
  });

  return res.data;
};

export const missionPlannerDistanceFetchers = {
  getDurations,
  getDistances,
};
